const isNumber = value => !Number.isNaN(parseFloat(value));

function reformatKey(k) {
  const keyParts = k.split('.');
  return keyParts.reduce((acc, section) => {
    let local = acc;
    if (!local) {
      local = section;
    } else if (isNumber(section)) {
      local += `[${section}]`;
    } else {
      local += `.${section}`;
    }
    return local;
  }, '');
}

const doFlattenObject = (object, prefix = '') => {
  const nestElement = (prev, value, key) =>
    value && typeof value === 'object'
      ? { ...prev, ...doFlattenObject(value, `${prefix}${key}.`) }
      : { ...prev, ...{ [`${prefix}${key}`]: value } };

  return Object.keys(object).reduce(
    (prev, element) => nestElement(prev, object[element], element),
    {},
  );
};

export const flattenObject = object => {
  const flattened = doFlattenObject(object);
  return Object.keys(flattened).reduce((acc, k) => {
    acc[reformatKey(k)] = flattened[k];
    return acc;
  }, {});
};
